import { cn } from "@/shared/lib/utils"

const SNOW = "#fff4f2"

export function MountainIllustration({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 200 150"
			fill="none"
			aria-hidden="true"
			className={cn("pointer-events-none", className)}
			preserveAspectRatio="xMaxYMax meet"
		>
			<defs>
				<linearGradient id="bp-far" x1="0" y1="0" x2="0" y2="1">
					<stop offset="0" stopColor="#3b2427" />
					<stop offset="1" stopColor="#1e1a1c" />
				</linearGradient>
				<linearGradient id="bp-lit" x1="0" y1="0" x2="0" y2="1">
					<stop offset="0" stopColor="#d9434a" />
					<stop offset="1" stopColor="#6e1c21" />
				</linearGradient>
				<linearGradient id="bp-shade" x1="0" y1="0" x2="0" y2="1">
					<stop offset="0" stopColor="#8e262c" />
					<stop offset="1" stopColor="#3f1216" />
				</linearGradient>
				<linearGradient id="bp-near" x1="0" y1="0" x2="0" y2="1">
					<stop offset="0" stopColor="#2b2123" />
					<stop offset="1" stopColor="#1c1c1f" />
				</linearGradient>
			</defs>

			<circle cx="160" cy="40" r="15" fill="#e5484d" opacity="0.2" />

			<path
				d="M40 150 L70 104 L80 110 L98 84 L110 94 L128 66 L138 76 L146 70 L164 96 L176 90 L204 130 L204 150 Z"
				fill="url(#bp-far)"
			/>

			<path
				d="M4 150 L26 120 L34 124 L50 100 L58 104 L72 78 L80 82 L100 34 L108 46 L114 42 L128 70 L136 66 L152 96 L160 94 L186 150 Z"
				fill="url(#bp-lit)"
			/>
			<path
				d="M100 34 L108 46 L114 42 L128 70 L136 66 L152 96 L160 94 L186 150 L118 150 L106 96 L110 70 Z"
				fill="url(#bp-shade)"
			/>
			<path d="M72 78 L80 82 L74 106 L82 150 L70 150 L68 104 Z" fill="#6e1c21" opacity="0.55" />
			<path d="M50 100 L58 104 L54 122 L48 150 L42 150 L46 118 Z" fill="#6e1c21" opacity="0.45" />

			<path
				d="M100 34 L108 46 L114 42 L119 52 L113 55 L108 51 L103 58 L98 52 L93 57 L89 50 L92 49 Z"
				fill={SNOW}
			/>

			<path
				d="M0 150 C24 134 56 132 88 141 C116 149 150 136 200 141 L200 150 Z"
				fill="url(#bp-near)"
			/>

			<line
				x1="100"
				y1="34"
				x2="100"
				y2="14"
				stroke={SNOW}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M100 14 L114 18.5 L100 23 Z"
				fill="#e5484d"
				className="origin-left [transform-box:fill-box] motion-safe:animate-[flag-wave_1.4s_ease-in-out_infinite]"
			/>
		</svg>
	)
}
